import Lottie from 'lottie-react';
import { useTheme } from 'styled-components';
import { authLoadingAnimation, Typography } from '@libs/components';

import { useCopy } from '@libs/hooks';
import { CopyIcon } from 'src/assets';
import { CopyLink } from '../copy-link/CopyLink';
import {
  ActionButton,
  AssetIconWrapper,
  AssetInfoTitle,
  Container,
  CustomPendingIcon,
  FlexCenter,
  IdContainer,
  InfoContainer,
  InfoRow,
  StatusContainer,
  Image,
  FlexColumnGap,
  Footer,
  FlexColumn,
  LottieWrapper,
  CustomCheckIcon,
  SwapDetailsButton,
  FooterRowContainer,
} from './styles';

const SwapMobileCard = () => {
  const { colors } = useTheme();
  const { handleCopy } = useCopy('hdhdhbjasdfkjac');
  return (
    <Container>
      <IdContainer>
        <Typography type="subHeadline" fontFamily="primaryBold">
          ID - hdhdhbjasdfkjac
        </Typography>
        <ActionButton onClick={handleCopy}>
          <CopyIcon />
        </ActionButton>
      </IdContainer>
      <StatusContainer>
        <Typography type="caption" fontFamily="primaryBold">
          Pending Deposit
        </Typography>
        <CustomPendingIcon />
      </StatusContainer>
      <InfoContainer>
        <InfoRow>
          <FlexCenter>
            <AssetIconWrapper>
              <Image src="https://bitnet-dev-uploads.s3.eu-central-1.amazonaws.com/btc.svg" />
            </AssetIconWrapper>
            <FlexColumnGap>
              <AssetInfoTitle type="bodyButton" fontFamily="primaryMedium">
                Confirming deposit:
              </AssetInfoTitle>
              <Typography type="subHeadline" fontFamily="primaryBold">
                1.58 ETH
              </Typography>
            </FlexColumnGap>
          </FlexCenter>
        </InfoRow>
        <InfoRow>
          <CopyLink
            title="Deposit Hash"
            description="123123123askjdbajks..djalsbdjka"
            link="bitnet.ge"
          />
        </InfoRow>
        <InfoRow>
          <AssetInfoTitle type="bodyButton" fontFamily="primaryMedium">
            Pending Blockchain Deposit:
          </AssetInfoTitle>
          <Typography type="subHeadline" fontFamily="primaryBold">
            6 min ago
          </Typography>
        </InfoRow>
      </InfoContainer>
      <Footer>
        <FooterRowContainer>
          <InfoRow>
            <FlexCenter>
              <CustomPendingIcon />
              <AssetInfoTitle type="bodyButton" fontFamily="primaryMedium">
                Awaiting
              </AssetInfoTitle>
            </FlexCenter>
            <FlexColumn>
              <Typography type="subHeadline" fontFamily="primaryBold">
                0.00 USDT
              </Typography>
              <FlexCenter>
                <AssetInfoTitle type="bodyButton" fontFamily="primaryMedium">
                  0.00 ETH
                </AssetInfoTitle>
              </FlexCenter>
            </FlexColumn>
          </InfoRow>
          <InfoRow>
            <FlexCenter>
              <LottieWrapper>
                <Lottie loop={true} animationData={authLoadingAnimation} />
              </LottieWrapper>
              <AssetInfoTitle type="bodyButton" fontFamily="primaryMedium">
                Exchanging
              </AssetInfoTitle>
            </FlexCenter>
            <FlexColumn>
              <Typography type="subHeadline" fontFamily="primaryBold">
                0.00 USDT
              </Typography>

              <AssetInfoTitle type="bodyButton" fontFamily="primaryMedium">
                0.00 ETH
              </AssetInfoTitle>
            </FlexColumn>
          </InfoRow>
          <InfoRow>
            <AssetInfoTitle type="bodyButton" fontFamily="primaryMedium">
              Withdrawing
            </AssetInfoTitle>
            <FlexColumn>
              <Typography type="subHeadline" fontFamily="primaryBold">
                0.00 USDT
              </Typography>
              <FlexCenter>
                <AssetInfoTitle type="bodyButton" fontFamily="primaryMedium">
                  0.00 ETH
                </AssetInfoTitle>
              </FlexCenter>
            </FlexColumn>
          </InfoRow>
          <InfoRow>
            <FlexCenter>
              <CustomCheckIcon />
              <AssetInfoTitle type="bodyButton" fontFamily="primaryMedium">
                Withdrawn
              </AssetInfoTitle>
            </FlexCenter>
            <FlexColumn>
              <Typography type="subHeadline" fontFamily="primaryBold">
                0.00 USDT
              </Typography>
              <FlexCenter>
                <AssetInfoTitle type="bodyButton" fontFamily="primaryMedium">
                  0.00 ETH
                </AssetInfoTitle>
              </FlexCenter>
            </FlexColumn>
          </InfoRow>
        </FooterRowContainer>
        <SwapDetailsButton>
          <Typography
            type="bodyButton"
            fontFamily="primaryBold"
            color={colors.text.default}
          >
            Swap Details
          </Typography>
        </SwapDetailsButton>
      </Footer>
    </Container>
  );
};
export default SwapMobileCard;
